import { Query } from '../shared/types/query.types';
import { toProgressBounds } from '../shared/utils/progress.utils';
import { pduPruToId } from './item.mapper';

export const convertFrontItemToQuery = (query: Query): Query => {
   const cloned: Query = structuredClone(query);
   if (cloned.unlocked === true) {
      cloned.locked = false;
      delete cloned.unlocked;
   }
   if (cloned.ssd !== undefined && cloned.ssd.length > 0) {
      cloned.saleStartDatesGlobal = cloned.ssd.map((value) => new Date(value.toString()));
      delete cloned.ssd;
   }
   if (cloned.eds !== undefined && cloned.eds.length > 0) {
      cloned.saleEndDatesGlobal = cloned.eds.map((value) => (value === 'Not set' ? new Date('2100-01-01') : new Date(value.toString())));
      delete cloned.eds;
   }
   if (cloned.progressState !== undefined) {
      cloned.progressBounds = toProgressBounds(cloned.progressState);
      delete cloned.progressState;
   }
   if (cloned.piaImportStatus !== undefined) {
      cloned.piaImportStatus.forEach((impStatus) => {
         if (impStatus === 'New') {
            cloned.newFromPia = true;
         } else if (impStatus === 'Updated') {
            cloned.updatedByPia = true;
         }
      });
      delete cloned.piaImportStatus;
   }
   if (cloned.buCodePru) {
      cloned.buCodePru = pduPruToId(cloned.buCodePru);
   }
   if (cloned.buCodePdu) {
      cloned.buCodePdu = pduPruToId(cloned.buCodePdu);
   }
   return cloned;
};